<template>
  <!-- 影像上传（4） -->
  <div class="supplementary" style="padding-bottom: 0.65rem;">
    <div class="li-content">
      <div class="border-style">
        <h3>影像信息</h3>
        <div class="tabs-choose">
          <div v-for="(item,index) in tabsContent" :key="index" class="each-tab" :class="{active:item.active}" @click="showMore(item,index)">
            {{ item.text }}
          </div>
        </div>
      </div>
      <div v-for="(item,key) in tabsContent" v-show="item.state" :key="key" class="border-style">
        <h3>{{ item.text }}</h3>
        <div class="img-choose">
          <div v-for="(item,index) in tabsContent[key].src" :key="index" class="img-content">
            <img class="delete-img" :src="deleteImg" alt="" @click="IMGRemove(item, key,index)">
            <img class="downLoad-img" :src="imgUrl + item.path" alt="">
          </div>
          <div v-if="tipVisible" class="img-content" @change="handleFile($event,key)">
            <input ref="fileBtn" type="file" multiple accept="image/*">
            <img class="downLoad-img" :src="imgUrlIcon" alt="">
          </div>
          <div v-if="tipVisibles" class="img-content" @click="handleFiles(key)">
            <img class="downLoad-img" :src="imgUrlIcon" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="li-content">
      <div class="border-style" @click="goSpecial">
        <mt-cell class="title-weight" title="特别约定" is-link />
      </div>
    </div>
    <div class="li-content">
      <div class="border-style">
        <h3 style="border-bottom: 1px solid #999999">
          备注说明
        </h3>
        <textarea v-model="remark" class="input-style" type="text" maxlength="500" placeholder="请输入备注信息，信息将在核保时展示" />
      </div>
    </div>
    <div class="next-step">
      <button class="save-btn" @click="save(true, true, 1)">
        暂存
      </button>
      <button @click="goNext">
        提交核保
      </button>
    </div>
    <div v-if="frame" class="ErrorTips">
      <div class="Bottoming">
        <div class="Bottoming-top" v-html="analysis">
          <div />
          {{ analysis }}
        </div>
        <div class="Bottoming-buttom" @click="determination">
          确定
        </div>
      </div>
    </div>
    <Loading :switchs="switchs" />
    <van-popup v-model="popupVisible" position="bottom" close-on-click-overlay>
      <van-picker :columns="columns" show-toolbar @confirm="onConfirm" @cancel="popupVisible = false" />
    </van-popup>
  </div>
</template>
<script>
import { Toast } from 'vant'
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
export default {
  components: {
    'Loading': Loading
  },
  data() {
    return {
      devUrl: api.devUrl,
      imgUrl: api.imgIdUrl,
      frame: false,
      switchs: false,
      tipVisible: false, // 其他进入
      tipVisibles: false, // APP 进入
      imgUrlIcon: api.imgAllUrl + '/sales400709.png',
      imgUrlExample: api.imgAllUrl + '/sales180709.png',
      deleteImg: api.imgAllUrl + '/sales240709.png',
      switchValue: false,
      active: false,
      fileIdList: [],
      tabsContent: [
        {
          text: '验车照',
          fileType: '1',
          state: false,
          show: false,
          src: []
        },
        {
          text: '车辆证件',
          fileType: '2',
          state: false,
          show: false,
          src: []
        },
        {
          text: '客户证件',
          fileType: '3',
          state: false,
          show: false,
          src: []
        },
        {
          text: '购车证明',
          fileType: '4',
          state: false,
          show: false,
          src: []
        },
        {
          text: '过户证明',
          fileType: '5',
          state: false,
          show: false,
          src: []
        },
        {
          text: '退保证明',
          fileType: '6',
          state: false,
          show: false,
          src: []
        },
        {
          text: '单证',
          fileType: '7',
          state: false,
          show: false,
          src: []
        },
        {
          text: '申请书',
          fileType: '8',
          state: false,
          show: false,
          src: []
        },
        {
          text: '其他',
          fileType: '9',
          state: false,
          show: false,
          src: []
        }
      ],
      deliveryInfo: {
        receivePhone: '',
        receiver: '',
        receiverAddress: '',
        receiverMail: ''
      },
      // 影像信息参数
      yxparam: {
        imageInfoList: [],
        orderId: ''
      },
      arr: '', // 特约返回数据
      keys: 0,
      analysis: '', // 提示内容
      jumpStatus: 0,
      popupVisible: false,
      networkCode: '',
      columns: [],
      // network: false
      remark: ''
    }
  },
  mounted() {
    // if (localStorage.getItem('setChannelCode') === 'ZKICATM') {
    //   this.network = true
    // }
    window.handleFiles = this.handleFiles
    window.pickImageBack = this.pickImageBack
    // let URL = window.location.href
    // if(URL.indexOf('terminalId=APP') !== -1) {
    //   this.tipVisibles = true
    //   this.tipVisible = false
    // } else {
    //   this.tipVisible = true
    //   this.tipVisibles = false
    // }
    this.tipVisible = true
    this.tipVisibles = false
  },
  activated() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.$store.commit('setStep', '4')
    this.$store.commit('setShow', true)
    this.arr = this.$route.params.arr
    if (this.$store.state.entrance === 0) {
      this.tabsContent = [
        {
          text: '验车照',
          fileType: '1',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '车辆证件',
          fileType: '2',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '客户证件',
          fileType: '3',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '购车证明',
          fileType: '4',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '过户证明',
          fileType: '5',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '退保证明',
          fileType: '6',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '单证',
          fileType: '7',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '申请书',
          fileType: '8',
          state: false,
          show: false,
          active: false,
          src: []
        },
        {
          text: '其他',
          fileType: '9',
          state: false,
          show: false,
          active: false,
          src: []
        }
      ]
      this.fileIdList = []
      if (this.$store.state.itemFileDataList && this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList && this.$store.state.itemFileDataList[0].fileList.length > 0) {
        this.$store.state.itemFileDataList[0].fileList.forEach(value => {
          const fileStreams = value.fileId
          const obj = {
            path: fileStreams
          }
          this.tabsContent[Number(value.fileType) - 1].src.push(obj)
          this.tabsContent[Number(value.fileType) - 1].state = true
          if (value.fileType === this.tabsContent[Number(value.fileType) - 1].fileType) {
            this.tabsContent[Number(value.fileType) - 1].active = true
          }
          const objs = {
            fileId: value.fileId,
            fileType: value.fileType
          }
          this.fileIdList.push(objs)
        })
      }
    }
  },
  deactivated() {
    Toast.clear()
    this.$store.commit('setStep', '')
  },
  methods: {
    onConfirm(value) {
      this.popupVisible = false
      this.networkCode = value.code
    },
    // APP获取图片
    handleFiles(key) {
      PickImage.postMessage('pickImageBack')
      this.keys = key
    },
    pickImageBack(result) {
      const acquire = 'data:image/png;base64,' + result
      const name = new Date().getTime()
      const that = this
      const param = {
        fileBase64: acquire.replace(/^.*?,/, ''),
        fileName: name + '.png',
        fileType: that.tabsContent[that.keys].fileType
      }
      this.switchs = true
      that.$http.post(api.uploadFile, param)
        .then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            const path = {
              path: res.data.fileId
            }
            that.tabsContent[that.keys].src.push(path)
            const obj = {
              fileName: name + '.png',
              fileId: res.data.fileId,
              fileType: that.tabsContent[that.keys].fileType
            }
            that.fileIdList.push(obj)
            that.save(true, false)
          } else {
            that.$toast(res.data.rtnMsg)
          }
          this.switchs = false
        })
        .catch(error => {
          Toast.clear()
          console.log(error)
          this.switchs = false
        })
    },
    showMore(item, index) {
      if (item.active) {
        this.$set(item, 'active', false)
        item.state = false
        this.tabsContent[index].src = []
        const fileIdLists = []
        this.fileIdList.forEach(value => {
          if (value.fileType !== item.fileType) {
            fileIdLists.push(value)
          }
        })
        this.fileIdList = fileIdLists
        this.save(true, false)
      } else {
        this.$set(item, 'active', true)
        item.state = true
      }
    },
    handleFile(event, key) {
      const fileList = event.target.files
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size >= 10 * 1000 * 1000) {
          this.$toast('图片不能大于10M!')
        } else {
          if (!fileList[i]) return
          // 禁止的格式
          const forbidden = ['html', 'htm', 'svg'];
          const ext = fileList[i].name.toLowerCase().split('.').pop();
          if (forbidden.includes(ext)) {
            this.$toast('不支持上传 html/htm/svg 文件！')
            this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
            return
          }
          console.log(this.$refs.fileBtn, 'fileBtn')
          if (this.$refs.fileBtn) {
            this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
          }
          const reader = new FileReader()
          reader.readAsDataURL(fileList[i])
          const that = this
          reader.onload = function(e) {
            const param = {
              fileBase64: e.target.result.replace(/^.*?,/, ''),
              fileName: fileList[i].name,
              fileType: that.tabsContent[key].fileType
            }
            that.switchs = true
            that.$http.post(api.uploadFile, param)
              .then(res => {
                Toast.clear()
                if (res.data.rtnCode === '0000') {
                  const path = {
                    path: res.data.fileId
                  }
                  that.tabsContent[key].src.push(path)
                  const obj = {
                    fileName: fileList[i].name,
                    fileId: res.data.fileId,
                    fileType: that.tabsContent[key].fileType
                  }
                  that.fileIdList.push(obj)
                  that.save(true, false)
                } else {
                  that.$toast(res.data.rtnMsg)
                }
                that.switchs = false
              })
              .catch(error => {
                Toast.clear()
                console.log(error)
                that.switchs = false
              })
          }
        }
      }
    },
    // 单个图片删除
    IMGRemove(item, key, index) {
      this.fileIdList.forEach((value, indexs) => {
        if (value.fileId === item.path) {
          this.fileIdList.splice(indexs, 1)
        }
      })
      this.save(true, false)
      this.tabsContent[key].src.splice(index, 1)
    },
    goSpecial() {
      this.$router.push('clause')
    },
    // 暂存
    save(values, datas, val) {
      if (values) {
        if (datas) {
          if (!this.$store.state.engageLists) {
            this.$toast('请选择特别约定')
            return false
          }
        }
        this.switchs = true
      }
      const imageInfoLists = []
      this.fileIdList.forEach(value => {
        const objs = {
          fileId: value.fileId,
          fileType: value.fileType
        }
        imageInfoLists.push(objs)
      })
      const JQfile = {
        businessNo: 10501237000019000000,
        riskCode: localStorage.getItem('whetherFeeChangeArea') === '1' ? '050A' : '0501'
      }
      const data = {
        orderId: this.$store.state.orderId,
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        itemFileDataList: [],
        terminalIdType: checkFormat.getPhoneLike(),
        submitInfo: {
          remark: this.remark
        }
      }
      if (imageInfoLists.length !== 0) {
        JQfile.fileList = imageInfoLists
        data.itemFileDataList.push(JQfile)
      }
      this.$http.post(api.save, data)
        .then(res => {
          if (values) {
            this.$store.commit('setItemFileDataList', res.data.resultObj.itemFileDataList)
            // if (checkFormat.interpretation(this.$store.state.terminalId, this.$store.state.channelCode).terminalId === 'APP') {
            //   this.$store.commit('setOrderId', data.orderId)
            // }
            if (val === 1) {
              this.$toast('暂存成功')
            }
            this.switchs = false
          }
        })
        .catch(error => {
          console.log(error)
          if (values) {
            this.switchs = false
          }
        })
    },
    determination() {
      this.frame = false
      checkFormat.SolveThrough(false)
      // let userToken = localStorage.getItem('setToken')
      // let channelCode = localStorage.getItem('setChannelCode')
      // let terminalId = localStorage.getItem('setTerminalId'),
      // if (this.jumpStatus === 1) {
      //   let URL = window.location.href
      //   if (URL.indexOf('token') !== -1) { // 微店进入
      //     let orderId = this.$store.state.orderId
      //     location.href = `${process.env.API_HOST}/app/mall/m-web/?url=/Client/index#/Succeed?channelCode=${channelCode}&terminalId=${terminalId}&token=${userToken}&orderId=${orderId}`
      //   } else { // 官微\ 全员营销进入
      //     location.href = `${process.env.API_HOST}/app/mall/m-web/?url=/Client/index#/Order?channelCode=${channelCode}&terminalId=${terminalId}&token=${userToken}`
      //   }
      // }
    },
    // 提交核保
    goNext() {
      if (!this.$store.state.engageLists) {
        this.$toast('请选择特别约定')
        return false
      } else {
        // this.save(false, false)
        this.submit()
      }
    },
    // 上传影像信息
    submit() {
      this.switchs = true
      const dataSet = {
        orderId: this.$store.state.orderId,
        engageList: this.$store.state.engageList,
        ordersAmount: this.$store.state.sumPremium,
        submitInfo: {
          remark: this.remark
        }
      }
      this.$http.post(api.submitUnderWrite, dataSet)
        .then(resA => {
          Toast.clear()
          if (resA.data.rtnCode === '0000') {
          // let URL = window.location.href
          // let receive = URL.split('?')[1].split('#')[0].split('&')
          // let orderId = false
          // receive.forEach(value =>{
          //   if (value.split('=')[0] === 'orderId') {
          //     orderId = true
          //   }
          // })
          // if (orderId) {
          //   this.$router.push({name:'Confirm'})
          // } else {
          //   console.log(this.$store.state.orderId, 'this.$store.state.orderId')
          //   this.$router.push({name:'Confirm',query:{orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode')}})
          // }

            // 可回溯修改 20200908 begin 因为只有提交核保成功，才能返回订单号保单号等信息，因此只有提交核保成功才调这个接口
            if (this.$store.state.traceBack) {
              try {
                this.traceBack(resA.data).finally(() => {
                  console.log('最后跳转')
                  this.$router.push({ name: 'Confirm', query: { orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode') }})
                })
              } catch (e) {
                this.$router.push({ name: 'Confirm', query: { orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode') }})
              }
            } else {
              this.$router.push({ name: 'Confirm', query: { orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode') }})
            }
          // 可回溯修改 end
          // this.$router.push({name:'Confirm',query:{orderId: this.$store.state.orderId, terminalId: localStorage.getItem('setTerminalId'), channelCode: localStorage.getItem('setChannelCode')}})
          } else if (resA.data.rtnCode === '9980') { // 核保中提示,点击确认跳转到订单列表页
            this.frame = true
            this.analysis = resA.data.rtnMsg
            this.jumpStatus = 1
            checkFormat.SolveThrough(true)
          } else { // 留在当前页
            this.frame = true
            this.analysis = resA.data.rtnMsg
            this.jumpStatus = 0
            checkFormat.SolveThrough(true)
          }
          this.switchs = false
        })
        .catch(error => {
          Toast.clear()
          console.log(error)
          this.switchs = false
        })
    },
    traceBack(data) {
      // data = {
      //   orderNo: '11',
      //   resultObj: {
      //     policyNo: '22'
      //   }
      // }
      return new Promise((resolve) => {
        if (!data || !data.orderNo || !data.resultObj || !(data.resultObj.policyNo || data.resultObj.policyNoCI)) {
          resolve()
        }
        try {
          const productInfo = checkFormat.interpretation(localStorage.getItem('setTerminalId'), localStorage.getItem('setChannelCode'))
          const customers = this.getCustomers()
          const dataSet = {
            request: {
              applyTime: new Date().getTime(),
              campaignId: productInfo.orderOrigin,
              campaignName: '紫金车险',
              customer: customers,
              iseeBiz: '',
              orderNo: data.orderNo,
              policyNo: data.resultObj.policyNo || data.resultObj.policyNoCI,
              underwritingTime: new Date().getTime()
            }
          }
          const a = window.getIseeBiz()
          a.then(r => {
            console.log(r, '可回溯码')
            dataSet.request.iseeBiz = r
            this.$http.post(api.traceBack, dataSet).finally(() => {
              resolve()
            })
          }, err => {
            resolve()
          }).catch(() => {
            resolve()
          })
        } catch (e) {
          resolve()
        }
      })
    },
    getCustomers() {
      // 投保人
      const applicantIn = this.$store.state.applicantIn
      console.log(applicantIn, '投保人')
      // 被保人
      const recognizeeIn = this.$store.state.recognizeeIn
      console.log(recognizeeIn, '被保人')
      const insuredList = []
      if (applicantIn) {
        insuredList.push({
          customIdNo: applicantIn.identifyNumber,
          customType: '1',
          customMobile: applicantIn.mobile,
          customName: applicantIn.insuredName,
          customIdType: this.getZhongAnIdentifyType(applicantIn.identifyType)
        })
      }
      if (recognizeeIn) {
        insuredList.push({
          customIdNo: recognizeeIn.identifyNumber,
          customType: '2',
          customMobile: recognizeeIn.mobile,
          customName: recognizeeIn.insuredName,
          customIdType: this.getZhongAnIdentifyType(recognizeeIn.identifyType)
        })
      }
      return insuredList
    },
    getZhongAnIdentifyType(zkingIdentifyType) {
      switch (zkingIdentifyType) {
        // 个人-------------------
        // 身份证
        case '01':
          return '111'
        // 户口薄
        case '02':
          return '113'
        // 中国护照
        case '03':
          return '414'
        // 军官证
        case '04':
          return '114'

        // 驾驶执照
        case '05':
          return '335'
        // 返乡证
        case '06':
          return '516'
        // 外国护照 ?待确认
        case '07':
          return '414'
          // 企业-------------------

        // 统一社会信用代码
        case '13':
          return '822'
        // 税务登记证
        case '12':
          return '824'
        // 工商营业执照
        case '11':
          return '821'
        // 组织机构代码证
        case '10':
          return '823'

        // 其它
        case '99':
          return '990'
        default:
          return '990'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./supplementaryold.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/supplementaryOld/index.vue